import React from "react";

import PageHeader from "Components/Pages/Header";
import PageWrapper from "Components/Pages/Wrapper";
import { Pagination } from "Components/Pagination";
import Breadcrumb from "Components/Shared/Breadcrumb";

import moment from "moment";

import { OrderList } from "./components/OrdersList";
import { ContentHolder } from "./styles";
import "react-dates/lib/css/_datepicker.css";
import "moment/locale/pt-br";
import { Filters } from "./components/Filters";
import { usePreOrderList } from "./usePreOrderList";

moment.locale("pt-br");

const PreOrderList = () => {
  const { preBudgetList, setNewPage, setProductFilters, handlePagination } =
    usePreOrderList();

  return (
    <PageWrapper className="entry-app-content ">
      <ContentHolder className="content-holder ">
        <div className="page-heading order-home-list">
          <div className="wrapper-header-content">
            <PageHeader title="Listagem de pré-orçamentos" className="lg-12">
              <Breadcrumb
                list={[
                  {
                    path: "#",
                    label: "Listagem pré-orçamentos",
                    current: true,
                  },
                ]}
              />
            </PageHeader>
          </div>
          <Filters
            setProductFilters={setProductFilters}
            productsQuantity={preBudgetList?.data?.total || 0}
            setNewPage={setNewPage}
          />
        </div>

        <OrderList
          orderList={preBudgetList?.data?.data}
          loading={preBudgetList.isLoading}
        />
      </ContentHolder>

      {!preBudgetList.isLoading &&
        preBudgetList.data?.last_page &&
        preBudgetList.data.last_page > 1 && (
          <div className="pagination-wrapper">
            <Pagination
              totalRecords={preBudgetList?.data?.last_page}
              currentPageSelected={preBudgetList?.data.current_page}
              pageLimit={1}
              pageNeighbours={1}
              onPageChanged={(e) => handlePagination(e)}
            />
          </div>
        )}
    </PageWrapper>
  );
};

export default PreOrderList;
